module.exports = __webpack_public_path__ + "img/background1.2015d346.jpg";